import React, { useContext, type ReactElement } from "react";

import { useTranslations } from "@rootreeweb/react-translations";

import { appContext } from "../shared/AppContextProvider.js";

/**
 * Displays a CTA for contacting sales about the missing fill information
 *
 * @returns The component.
 */
export default function ContactSalesLink(): ReactElement {
	const { links } = useContext(appContext);
	const { getTranslation } = useTranslations();
	return <a href={links["contact-sales"]}>{getTranslation("contact-sales")}</a>;
}
